import { Component, OnInit, Input } from '@angular/core';
import { ScaleResult } from '../../shared/models/scale-result';
import { CopyClipboardService } from 'app/shared/services/copy-clipboard.service';

@Component({
  selector: 'dac-scale-sub-list',
  templateUrl: './scale-sub-list.component.html',
  styleUrls: ['./scale-sub-list.component.scss']
})
export class ScaleSubListComponent implements OnInit {

  @Input("SubScales") SubScales:ScaleResult[];

  constructor(private copyClipboardService:CopyClipboardService) { 
    this.SubScales = [];
  }

  ngOnInit() {
  }

  public copyTable() {
    let copyTable = [];
    copyTable.push(["Sub Scale", "Description", "Raw Score","Range"]);
    if (this.SubScales.length) {
      this.SubScales.forEach(sr => {
        let row = [];
        row.push(sr.scale.name ? '"' + sr.scale.name + '"' : '');
        row.push(sr.scale.descriptionClient ? '"' + sr.scale.descriptionClient + '"' : '');
        row.push(sr.score);
        row.push(sr.range.name ? '"' + sr.range.name + '"' : '');
        copyTable.push(row);
      });
    }
    this.copyClipboardService.copyTableToText(copyTable);
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/scale-sub-list/scale-sub-list.component.ts